import React, { FC } from 'react';
import { Form } from 'antd';

// Shared UI Library Components
import { NumberInput } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './rate-filter.scss';

type TRateFilterProps = {};

export const RateFilter: FC<TRateFilterProps> = (
  {}: TRateFilterProps
) => {

  return (
    <div className="rate-filter">
      <div className="rate-filter--item">
        <Form.Item name={ 'rate_from' }>
          <NumberInput placeholder={ 'Min' } min={ 0 } max={ 1000 } controls={ false } />
        </Form.Item>
      </div>
      <div className="rate-filter--item">
        <Form.Item name={ 'rate_to' }>
          <NumberInput placeholder={ 'Max' } min={ 0 } max={ 1000 } controls={ false } />
        </Form.Item>
      </div>
    </div>
  );
}
